import axios from 'axios';
import Cookies from 'js-cookie';
import CookieConsent from './CookieConsent';
import DataStore from './DataStore';
import Menu from './Menu';
// import Tracker from './Tracker'; // jelenleg nincs rá szükség az egyszerűsített gtag és fbq consent beállítások miatt
import { responsiveTable, responsiveEmbed, watchBreakpoint } from './utils';

export {
  axios,
  Cookies,
  CookieConsent,
  DataStore,
  Menu,
  responsiveEmbed,
  responsiveTable,
  watchBreakpoint,
  // Tracker,
};
